module.exports = __webpack_public_path__ + "static/media/shutterstock_645685942-800x450 (1) (1).6beff1cf.jpg";